export class JobDeleteV2{
    jobAlertIds: number[]=[];
    deleteAllJobAlerts:boolean= false;
    companyCode:string= "";
    email:string=""
  
 
}
